import { loginApi } from "@/api/authApi";
import { CredentialsType } from "@/common/types";
import {
  clearAuthFromLocalStorage,
  setAuthToLocalStorage,
} from "@/utils/common.util";
import { setLoader } from "./commonActions";
import { AxiosError } from "axios";

export const login =
  (
    payload: CredentialsType,
    callback: () => void,
    failureCallback: (message: string) => void
  ) =>
  async (dispatch: any) => {
    dispatch(setLoader(true));
    try {
      const formData = new FormData();
      formData.append("username", payload.username);
      formData.append("password", payload.password);
      const response = await loginApi(formData);
      if (response) {
        setAuthToLocalStorage(response);
        callback();
      }
    } catch (error) {
      console.log(error);
      if (error instanceof AxiosError) {
        if (error.status === 400) {
          failureCallback(
            "The email and password you entered did not match our records. Please double-check and try again."
          );
        } else {
          failureCallback("Something went wrong");
        }
      } else {
        failureCallback("Something went wrong");
      }
    }
    dispatch(setLoader(false));
  };

export const logout = (callback: () => void) => async () => {
  try {
    clearAuthFromLocalStorage();
    callback();
  } catch (error) {
    console.log(error);
  }
};
